import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authFetch } from '../../api';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import ZenGridLogo from '../../common/ZenGridLogo';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const res = await authFetch('sign-in/email', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    });

    setLoading(false);

    if (res?.status === 'success') {
      localStorage.setItem('user_id', res.data.user.id);
      navigate('/');
    } else {
      setError(res?.error || 'ログインに失敗しました');
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center bg-gradient-to-br from-slate-100 via-indigo-50 to-sky-100 dark:from-[#0a0a12] dark:via-[#0f0f1a] dark:to-[#111124] p-4 transition-colors duration-300">
      <div className="pointer-events-none absolute -top-24 -left-24 w-80 h-80 bg-primary-400/30 dark:bg-primary-500/20 rounded-full blur-[100px]" />
      <div className="pointer-events-none absolute bottom-0 -right-24 w-80 h-80 bg-sky-300/30 dark:bg-indigo-500/20 rounded-full blur-[100px]" />

      <div className="relative max-w-md w-full glass-panel rounded-3xl p-8">
        <div className="flex justify-center mb-6">
          <span className="w-16 h-16 rounded-2xl overflow-hidden shadow-lg shadow-primary-600/20">
            <ZenGridLogo className="w-full h-full" />
          </span>
        </div>
        <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white mb-2 tracking-tight">ZenGrid</h2>
        <p className="text-sm text-center text-gray-500 dark:text-gray-400 mb-6 font-medium">AIアシスト搭載の9マス目標達成ツール</p>

        {error && (
          <div className="mb-4 p-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-600 dark:text-red-400 text-sm font-medium">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-800 dark:text-gray-200 mb-1.5">メールアドレス</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="glass-input" placeholder="you@example.com" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-800 dark:text-gray-200 mb-1.5">パスワード</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="glass-input" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} className="w-full py-3 glass-btn-primary flex justify-center items-center gap-2">
            {loading ? <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" /> : 'ログイン'}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-700 dark:text-gray-300 font-medium">
          アカウントをお持ちでないですか？{' '}
          <Link to="/signup" className="text-primary-600 dark:text-primary-400 font-bold hover:underline">新規登録</Link>
        </div>
      </div>
    </div>
  );
}